module.exports = __webpack_public_path__ + "img/pic_1.702f909d.jpg";